




















































































import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import DeliveryTab from '@/components/delivery/DeliveryTab.vue';
import { ncpPopup } from '@/utils/ncp';
import { htmlRestore } from '@/utils/formatUtils';
import { Areafee } from 'supporter';

@Component({
  components: {
    PageTitle,
    DeliveryTab,
  },
})
export default class DeliveryAreaFeeList extends Vue {
  private areaFees: Areafee[] = [];
  private selectedAreaFeeNos: number[] = [];
  private htmlRestore = htmlRestore;
  fetchAreaFees() {
    const params = {
      page: 1,
      size: 1500,
    };
    this.$api.getAreafees({ params }).then(ret => {
      if (ret && ret.data) {
        this.areaFees = ret.data.contents;
      }
    });
  }
  created() {
    this.fetchAreaFees();
  }
  private clickCheckBox(checked: boolean, areaFeeNo: number) {
    if (checked) {
      this.selectedAreaFeeNos.push(areaFeeNo);
    } else {
      const ret = this.selectedAreaFeeNos.indexOf(areaFeeNo);
      if (ret > -1) {
        this.selectedAreaFeeNos.splice(ret, 1);
      }
    }
  }

  private makeCountryLabel(value: string) {
    return value === 'KR' ? '대한민국' : '글로벌';
  }

  private checkAll(checked: boolean) {
    if (checked) {
      this.areaFees.forEach(item => {
        this.selectedAreaFeeNos.push(item.areaFeeNo);
      });
    } else {
      this.selectedAreaFeeNos = [];
    }
  }
  private deleteAreaFee() {
    if (this.selectedAreaFeeNos) {
      if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_LIST_CONFIRM1').toString())) {
        this.$api
          .deleteAreafeesBulk({
            params: {
              areaFeeNos: this.selectedAreaFeeNos.toString(),
            },
          })
          .then(() => {
            this.fetchAreaFees();
            this.selectedAreaFeeNos = [];
          });
      }
    } else {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_LIST_ALERT1'));
    }
  }
  private goModify(areaFeeNo: number) {
    ncpPopup(
      `/deliveryAreaFee/modifyForm?areaFeeNo=${areaFeeNo}`,
      this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_LIST_MODIFY').toString(),
      754,
      800,
    );
  }
  private goAdd(areaFeeNo?: number) {
    if (areaFeeNo) {
      ncpPopup(
        `/deliveryAreaFee/modifyForm??areaFeeNo=${areaFeeNo}&copy=true`,
        this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_LIST_ADDED').toString(),
        800,
        800,
      );
    } else {
      ncpPopup(
        '/deliveryAreaFee/modifyForm',
        this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_LIST_ADDED').toString(),
        1024,
        800,
      );
    }
  }
}
